import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"
import { Card, CardBody } from "reactstrap"

class ContactDetailMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        const {isResponsive} = this.props;
        const navItems = [
            {
                id: 'contact-detail',
                label: 'Activities',
                link: `/contact/contact-detail/${this.props.match.params.id}/${this.props.match.params.contactid}`
            },
            {
                id: 'additional-profile',
                label: 'Additional Profile',
                link: `/contact/additional-profile/${this.props.match.params.id}/${this.props.match.params.contactid}`
            },
            {
                id: 'referrals',
                label: 'Referrals',
                link: `/contact/referrals/${this.props.match.params.id}/${this.props.match.params.contactid}`
            },
          
        ];
          const currentPath = this.props.location.pathname;
        return (
            <React.Fragment>
                {isResponsive ? (
       <div className="mobile-contact-menu">
        <Card>
            <CardBody>
                <h6>Select Menu</h6>
                 <select
          className="form-select mb-3"
          value={currentPath}
          onChange={(e) => this.props.history.push(e.target.value)}
        >
          {navItems.map((item) => (
            <option key={item.id} value={item.link}>
              {item.label}
            </option>
          ))}
        </select>         
            </CardBody>
        </Card>
               
       </div>
       
      ) : (
       
        <TabNavigation navItems={navItems} />
      )}

               
            </React.Fragment>
        )
    }
}
ContactDetailMenu.propTypes = {
    match: PropTypes.object,
    isResponsive:PropTypes.object,
    history:PropTypes.object,
    location:PropTypes.object
}
export default withRouter(ContactDetailMenu)
